// Category.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./CategorySection.css";

const Category = () => {
  const categories = [
    "اقتصاد ایران",
    // "بورس",
    // "بانک، بیمه و بورس",
    "صنعت",
    "کشاورزی",
    "راه و ساختمان",
    "انرژی",
  ];

  const [page, setPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [newsData, setNewsData] = useState([]);
  const [featuredNews, setFeaturedNews] = useState(null);
  const [error, setError] = useState(null);

  // NEW: State to track total pages
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        const response = await axios.get(
          `https://khanehyeghtesad.com:8000/api/category/${selectedCategory}/page/${page}/`
        );
        // API returns an object like: { articles: [...], total_pages: N }
        const { articles, total_pages } = response.data;

        setNewsData(articles);
        setTotalPages(total_pages || 1); // Fallback in case it's null/undefined

        if (articles && articles.length > 0) {
          setFeaturedNews(articles[0]);
        } else {
          setFeaturedNews(null);
        }
      } catch (err) {
        // setError("Failed to fetch data. Please try again later.");
        // console.error("Error fetching category data:", err);
      }
    };

    fetchCategoryData();
  }, [selectedCategory, page]);

  // Reset page to 1 when category changes
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setPage(1);
  };

  // Slice out the featured news from the rest
  const otherNews = newsData.slice(1);

  return (
    <div className="category-container-category">
      {/* Navbar for categories */}
      <nav className="navbar-category">
        <ul className="navbar-list-category">
          {categories.map((category) => (
            <li key={category} className="navbar-item-category">
              <button
                className={`navbar-button-category ${
                  selectedCategory === category ? "active-category" : ""
                }`}
                onClick={() => handleCategoryChange(category)}
              >
                {category}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Main Content */}
      <div className="content-category">
        {error && <p className="error-message">{error}</p>}

        {/* Featured Section */}
        {featuredNews && (
          <div className="featured-section-category">
            <h2 className="section-title-category"></h2>
            <div className="article-category">
              
              <Link
                to={`/article/${featuredNews.slug}`}
                className="featured-link-category"
              >
                {featuredNews.image_file ? (
                <img
                  src={`data:image/jpeg;base64,${featuredNews.image_file}`}
                  alt="Featured"
                  className="featured-image-category"
                />
              ) : (
                <div className="no-image-placeholder">تصویری موجود نیست</div>
              )}

                <p className="summary-category">{featuredNews.quote}</p>
                {/* TITLE */}
                <h3 className="featured-title-category">
                  {featuredNews.title}
                </h3>
                <p className="summary-category">
                  {featuredNews.caption.length > 100
                    ? `${featuredNews.caption.substring(0, 100)}...`
                    : featuredNews.caption}
                </p>
              </Link>

              <div className="meta-category">
                <span>{featuredNews.jalali_full_date || ""}</span>
              </div>
            </div>
          </div>
        )}

        {/* List of Other Articles */}
        <div className="post-list-category">
          <h2 className="section-title-category"></h2>
          <ol className="post-list-items-category">
            {otherNews.map((post) => (
              <li key={post._slug} className="post-item-category">
                <p className="summary-category">{post.quote}</p>

                <Link to={`/article/${post.slug}`} className="post-link-category">
  <h3 className="post-title-category">{post.title}</h3>
  <p className="summary-category">
    {post.caption.length > 100
      ? `${post.caption.substring(0, 100)}...`
      : post.caption}
  </p>
  <span className="post-date-category">
    {post.jalali_full_date}
  </span>
</Link>

              </li>
            ))}
          </ol>

          {/* Pagination Controls */}
          <div className="pagination-container-cat">
            {/* Prev Button */}
            <button
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              disabled={page === 1}
            >
              قبلی
            </button>

            {/* (Optional) Show current page */}
            {/* <span className="page-number">{page}</span> */}

            {/* Next Button */}
            <button
              onClick={() => setPage((prev) => prev + 1)}
              // Disable when current page >= totalPages
              disabled={page >= totalPages}
            >
              بعدی
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Category;
